/**
 * @module common/api/roskvartal-api
 * @requires module:common/config/url-config~UrlConfig
 * @requires module:common/dto/landing-order~LandingOrderDTO
 */

import axios from 'axios';
import { UrlConfig } from '@/common/config';
import { LandingOrderDTO } from '@/common/dto';
import { generateControllerStates } from '@roskvartal-landings/util-generate-controller-states';
import { controllerMutations } from '@roskvartal-landings/mixin-controller-mutations';

/**
 * @const
 * @description Экземпляр axios для работы с API
 */
const api = axios.create({
  baseURL: UrlConfig.baseOrderUrl,
  timeout: 10000,
});

/**
 * @const
 * @description Список методов в контроллере
 */
const methods = ['order'];

const state = generateControllerStates(methods);

const mutations = {
  ...controllerMutations(state),
};

/** API для roskvartal.ru */
class RoskvartalApi {
  /**
   * @description - Отправляет запрос на заказ обратного звонка
   * @param {Object} payload - Данные запроса
   * @returns {Promise}
   */
  static order(payload) {
    try {
      const data = new LandingOrderDTO(payload);
      return api({
        method: 'post',
        url: '/order',
        withCredentials: false,
        data,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * @readonly
   * @description Мутации контроллера
   * @mixes module:common/mixins/controller-mutations~controllerMutations
   */
  static get mutations() {
    return mutations;
  }

  /**
   * @member {module:common/utils/generate-controller-states~ActionState[]}
   * @readonly
   * @description Состояние контроллера. Изменяется посредством вызова мутаций
   */
  static get state() {
    return state;
  }
}

export default RoskvartalApi;
